import { RootState } from '../store';
import { CartBillType, PaymentsStore } from '../store/cart/types';
import { DHLPaymentRequestType } from '../types/sprintpay';

export const selectCartReducer = ({ cartReducer }: RootState): PaymentsStore => cartReducer;

export const selectCart = ({ cartReducer }: RootState): DHLPaymentRequestType[] => cartReducer.dhlPaymentRequests;

export const selectCartBill = ({ cartReducer }: RootState): CartBillType => cartReducer.cartBill;
